import { render, staticRenderFns } from "./wrfib.vue?vue&type=template&id=122d9726&scoped=true"
import script from "./wrfib.vue?vue&type=script&lang=js"
export * from "./wrfib.vue?vue&type=script&lang=js"
import style0 from "./wrfib.vue?vue&type=style&index=0&id=122d9726&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122d9726",
  null
  
)

export default component.exports